import { IJsonQuery } from '@cian/api-models/common/json_query';
import { intersection } from 'ramda';

import { IRegionSpecialPromo } from '../../types/specialPromos';
import { PIK_PROMO_REGIONS, PIK_PROMO } from '../../constants/pik';

export function getAvailableSpecialPromo(
  specialPromos: IRegionSpecialPromo[],
  jsonQuery: IJsonQuery,
): IRegionSpecialPromo | undefined {
  const currentRegion = jsonQuery.region?.value;
  let specialPromo: IRegionSpecialPromo | undefined;
  if (currentRegion) {
    if (intersection(PIK_PROMO_REGIONS, currentRegion).length > 0) {
      specialPromo = PIK_PROMO;
    } else {
      specialPromo = currentRegion
        ? specialPromos.filter(specialPromo => currentRegion.some(region => specialPromo.region === region))[0]
        : undefined;
    }
  }

  return specialPromo;
}
